import { uiClasses } from './ui-constants';

/* eslint-disable import/prefer-default-export */
export function renderApplePayUI(
  container: HTMLElement,
  action: io.flow.v0.models.ActionUseSdkApplepayJsCreateSession,
  buttonClickHandler: (event: Event) => void,
): void {
  const apContainer = document.createElement('div');
  apContainer.setAttribute('class', `${uiClasses.whitePanel}`);

  const iconContainer = document.createElement('div');
  iconContainer.setAttribute('class', `${uiClasses.iconContainer}`);
  iconContainer.innerHTML = '<svg width="12" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.15 11.758V7c0-.803.332-1.234.997-1.294V4.368c0-1.15.31-2.074.93-2.773.619-.7 1.429-1.049 2.43-1.049.992 0 1.797.35 2.417 1.049.62.699.929 1.623.929 2.773v1.338c.664.06.996.49.996 1.294v4.758c0 .863-.401 1.294-1.204 1.294h-6.29c-.803 0-1.205-.431-1.205-1.294zm2.394-6.067h3.911V4.19c0-.685-.178-1.24-.535-1.666-.357-.426-.828-.64-1.413-.64-.585 0-1.058.214-1.42.64-.362.426-.543.982-.543 1.666V5.69z" fill="#6C7682"/></svg>';

  const paymentDetails = document.createElement('div');
  const instructionsP = document.createElement('p');
  instructionsP.appendChild(
    document.createTextNode('Complete your payment'),
  );
  instructionsP.setAttribute('class', `${uiClasses.instructionalText}`);

  const paymentAmount = document.createElement('div');
  paymentAmount.appendChild(document.createTextNode(
    new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: action.payment_data_request.currency_code,
    }).format(parseFloat(action.payment_data_request.total.amount)),
  ));
  paymentAmount.setAttribute('class', `${uiClasses.paymentAmount}`);
  paymentDetails.appendChild(instructionsP);
  paymentDetails.appendChild(paymentAmount);

  const applePayButton = document.createElement('div');
  applePayButton.setAttribute('role', 'button');
  applePayButton.setAttribute('tabindex', '0');
  applePayButton.setAttribute('class', uiClasses.applePayButton);
  applePayButton.addEventListener('click', buttonClickHandler);

  const helperText = document.createElement('p');
  helperText.setAttribute('class', `${uiClasses.subText}`);
  helperText.appendChild(document.createTextNode('This window will close automatically when the payment process is complete.'));
  apContainer.appendChild(iconContainer);
  apContainer.appendChild(paymentDetails);
  apContainer.appendChild(applePayButton);
  apContainer.appendChild(helperText);
  container.appendChild(apContainer);
}
